import { AVATAR_COUNT, AVATAR_PALETTE } from '@/components/PresetAvatar/colors'
import type { LeaderboardEntry } from '@/types'

function hashName(name: string): number {
    let hash = 5381
    for (let i = 0; i < name.length; i++) {
        hash = Math.imul(hash, 33) ^ name.charCodeAt(i)
    }
    return hash >>> 0
}

export function getAvatarIndex(name: string): number {
    return hashName(name) % AVATAR_COUNT
}

export function getAvatarColorIndex(name: string): number {
    return hashName(name) % AVATAR_PALETTE.length
}

export function shortenDisplayName(name: string): string {
    return name.trim().split(/\s+/).slice(-2).join(' ')
}

const SHORT_ROWS = 5
const LONG_ROWS = 8

export function matchUser(
    user: LeaderboardEntry | null | undefined,
    entries: LeaderboardEntry[],
): LeaderboardEntry | null {
    if (!user) {
        return null
    }
    const atRank = entries.find((entry) => entry.rank === user.rank)
    return atRank && atRank.display_name !== user.display_name ? null : user
}

export function getUserSlot(rank: number | undefined, entries: LeaderboardEntry[]) {
    if (rank === undefined || entries.slice(0, SHORT_ROWS).some((entry) => entry.rank === rank)) {
        return 'none'
    }
    return entries.slice(0, LONG_ROWS).some((entry) => entry.rank === rank) ? 'short' : 'both'
}
